<template>
  <form ref="form" class="comment-form" action @submit.prevent="reply">
    <h5 class="title">{{ $t(`blog.comments.reply_to`, {author: parent.author.name}) }}</h5>
    <textarea
      v-model="comment.content"
      name="comment"
      cols
      rows="3"
      maxlength="255"
      required
      :disabled="loading"
    ></textarea>
    <div class="actions">
      <Button
        type="submit"
        :disabled="loading"
      >{{ $t('blog.comments.send') }}</Button>
    </div>
  </form>
</template>
<script>
import Button from '../../../common/Button';

export default {
  name: 'Reply',
  components: {
    Button,
  },
  props: {
    parent: {
      type: Object,
      description: 'Parent comment object',
      required: true,
    },
  },
  data: () => ({
    loading: false,
    comment: {
      content: '',
    },
  }),
  methods: {
    async reply() {
      if (!this.$refs.form.reportValidity()) return;
      try {
        const { data } = await window.axios
          .post(`/api/blog/comments/${this.parent.id}/reply`, {
            content: this.comment.content,
          });
        this.comment.content = '';
        this.$emit('saved', data.comment);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.comment-form .title {
  align-self: flex-start;
  margin-bottom: .2rem;
}
.comment-form {
  display: flex;
  align-content: center;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
}
.comment-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: .3rem;
  border: 1px solid var(--blog-border);
  border-radius: 8px;
}
.comment-form textarea[disabled] {
  border-color: #e2e2e2;
}
</style>
